import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { hotbPremiseBuildingType } from '@/utils/locale'
import { markHotbDashboardListStale } from '@/store/dashboardListStale'

export async function list (params, isSilentGet = false) {
  try {
    const query = params ? `/hotb?${params}` : '/hotb'
    let response
    if (isSilentGet) {
      response = await HTTP.silentGet(query)
    } else {
      response = await HTTP.get(query)
    }
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    return null
  }
}

export async function listAll (params, diskCacheKey) {
  try {
    const response = await HTTP
      .diskCache(diskCacheKey)
      .get('/hotb/all', { params })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    throw err
  }
}

export async function getHotb (id) {
  try {
    const response = await HTTP.get(`/hotb/${id}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    return null
  }
}

export async function createHotb (tenancy = {}, type) {
  try {
    const response = await HTTP.post('/hotb', {
      tenancyId: tenancy.id,
      premiseBuildingType: hotbPremiseBuildingType.asIs,
      type,
    })
    markHotbDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    return null
  }
}

export async function updateHotb (id, hotb, notify = true, action) {
  try {
    const request = {
      basicInfo: {
        ...hotb,
      },
    }
    const response = await HTTP.put(`/hotb/${id}`, request, { headers: { 'X-CMS-Action': action } })
    if (notify) {
      notification.handleResponseAlert(response)
    }
    markHotbDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleServerErrorMessage(err, 'hotb')
    throw err
  }
}

export async function updateHotbUpdatedBy (id, request) {
  try {
    const response = await HTTP.put(`/hotb/${id}/updatedBy`, request)
    notification.handleResponseAlert(response)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    throw err
  }
}

export async function logHotbChange (id, request, action) {
  try {
    await HTTP.patch(`/hotb/log/${id}`, request, { headers: { 'X-CMS-Action': action } })
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
  }
}

export async function patchStatus (id, request, action) {
  try {
    const response = await HTTP.patch(`/hotb/${id}`, request, { headers: { 'X-CMS-Action': action } })
    notification.handleResponseAlert(response)
    markHotbDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'hotb')
    return null
  }
}
